module.exports = __webpack_public_path__ + "static/media/Icon - Cart - Blue.2f7df08d.svg";